export enum AuthActionTypes {
  //Login
  Login = "Auth/Login",
  LoginSuccess = "Auth/LoginSuccess",
  LoginFail = "Auth/LoginFail",

  // LogOut
  LogOut = "Auth/LogOut",
  LogOutSuccess = "Auth/LogOutSuccess",
  LogOutFail = "Auth/LogOutFail",
}
